import { Company } from './company';
import { Device } from './device';
import { User } from './user';
import { Client } from '../client';

export type CodeGenReportFilterOptions =
	Components.Schemas.CodeGenReportFilterOptions;
export type InventoryReportFilterOptions =
	Components.Schemas.InventoryReportFilterOptions;

export const emptyCodeGenReportFilters = (): CodeGenReportFilters => ({
	codeTypeId: '',
	device: [],
	deviceOwner: [],
	dateGeneratedStartDate: undefined,
	dateGeneratedEndDate: undefined,
	dateValidStartDate: undefined,
	dateValidEndDate: undefined,
	assignedTo: [],
	generatedBy: [],
	firstName: [],
	lastName: [],
	clientIdn: [],
});

export type CodeGenReportFilters = {
	codeTypeId?: string;
	device?: { id: string; serialNumber: string }[];
	deviceOwner?: { id: string; name: string }[];
	dateGeneratedStartDate?: Date;
	dateGeneratedEndDate?: Date;
	dateValidStartDate?: Date;
	dateValidEndDate?: Date;
	assignedTo?: {
		id: string;
		firstName: string;
		lastName: string;
		email: string;
		displayName: string;
	}[];
	generatedBy?: {
		id: string;
		firstName: string;
		lastName: string;
		email: string;
		displayName: string;
	}[];
	firstName?: Client[];
	lastName?: Client[];
	clientIdn?: Client[];
};

export type InventoryReportFilters = {
	devices?: Device[];
	properties?: Location[];
	statuses?: Device[];
	dateChangedUtcStart?: Date | undefined;
	dateChangedUtcEnd?: Date | undefined;
};
